import { Button } from '@material-ui/core';
import { GenericHeader, SearchBar } from 'components';
import React from 'react';
import { Product } from 'services';
import { CreateModal, Results } from './components';
import ListComp from 'components/ListComp';

const ProductList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader header="All Products" subheader="Product Management" {...rest} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Product
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Product.list}
      title="Products"
      name="products"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default ProductList;
